/* Response Time CSS */

export default theme => ({
    square: {
        color: '#fff',
        backgroundColor: '#2199E8',
        borderRadius: 5,
        padding: '25px'
      }

});

